import { placeholderInSelection } from '..';
export default function makeOnChange(_ref) {
  var store = _ref.store;
  return {
    onChange: function onChange(editor, next) {
      var placeholder = placeholderInSelection(editor, store);

      if (!placeholder) {
        if (store.getItem('selectedPlaceholder')) {
          editor.command('deselectPlaceholder');
        }

        return next();
      }

      if (!placeholder.edition && !placeholder.selected) {
        if (editor.value.selection.isCollapsed) {
          editor.moveToStartOfInline().command('selectPlaceholder', {
            key: placeholder.key
          });
        } else {
          var selection = editor.value.selection;
          var isDirectionForward = selection.isCollapsed && !store.getItem('mouseDown') ? store.getItem('isForward') : selection.isForward;
          var direction = isDirectionForward ? 'End' : 'Start';
          var anchor = selection.isCollapsed ? '' : direction;
          var nextPosition = isDirectionForward ? 'StartOfNext' : 'EndOfPrevious'; // collapsed forward -> moveToStartOfNextText
          // collapsed barckward -> moveToEndOfPreviousText
          // selected forward -> moveEndToStartOfNextText
          // selected barckward -> moveStartToEndOfPreviousText

          editor["move".concat(anchor, "To").concat(nextPosition, "Text")]();
        }
      }

      next();
    }
  };
}